import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { ClientService } from './client.service';
import { Client, CognitoUser, StrideAssessment, StrideAssessmentPayload } from '@mira-avant/mtlibs';

@Injectable({
	providedIn: 'root',
})
export class AssessmentService {
	private readonly BASE_PATH = 'assessments';
	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(
		private api: ApiService,
		private authService: AuthService,
		private clientService: ClientService
	) {}

	private async withLoading<T>(operation: () => Promise<T>): Promise<T> {
		this.loading$.next(true);
		try {
			return await operation();
		} finally {
			this.loading$.next(false);
		}
	}

	public async createStrideAssessment$(
		payload: Omit<StrideAssessmentPayload, 'client_uuid' | 'student_cognito_uuid'>
	): Promise<StrideAssessment> {
		return this.withLoading(async () => {
			const user: CognitoUser | null = await firstValueFrom(this.authService.user$);
			if (!user) {
				throw new Error('No user found');
			}

			const client: Client = await firstValueFrom(this.clientService.selectedClient$);

			const fullPayload: StrideAssessmentPayload = {
				...payload,
				client_uuid: client.uuid,
				student_cognito_uuid: user.uuid,
			};

			return firstValueFrom(
				this.api.post<StrideAssessment>(`${this.BASE_PATH}`, fullPayload)
			);
		});
	}
}
